export default class ErrorHandler {
    constructor() {
        this.HEADER_CUSTOM_ERROR_HANDLING = 'X-Client-Custom-Error-Handling';
    }

    hasCustomErrorHandling(headers) {
        return headers.hasOwnProperty(this.HEADER_CUSTOM_ERROR_HANDLING);
    }

    enableCustomErrorHandling(headers) {
        headers[this.HEADER_CUSTOM_ERROR_HANDLING] = 1;

        return headers;
    }
}
